export default "__VITE_ASSET__BN8U$LKO__"